import store from "@/store";
import { CouponData, ProposalItem } from "@/model/Coupon";
import { InspectDetail } from "@/model/InspectDetail";

const namespace = "InspectionDetail";

export class InspectionProposalDetailStoreService {
  private proposalList: ProposalItem[] = [];
  deSelProposal: boolean = false;

  // サービス初期化時にご提案の選択管理枠をStoreへ登録する
  constructor() {
    this.addNowSelected();
  }

  // ご提案が選択済みかどうかを参照する
  get nowSelected(): boolean {
    const nowSelected = store.getters[`${namespace}/getNowSelected`];
    if (nowSelected.proposal === true || nowSelected.proposal === false) {
      return nowSelected.proposal;
    }
    this.addNowSelected();
    return false;
  }

  // ご提案の選択管理枠をStoreへ追加する
  addNowSelected() {
    return store.dispatch(`${namespace}/addNowSelected`, "proposal");
  }

  // ご提案の選択済み状態をStoreへ反映する
  setNowSelected(payload: boolean) {
    return store.dispatch(`${namespace}/setNowSelected`, {
      key: "proposal",
      value: payload
    });
  }

  // 共通処理から扱うご提案一覧を参照する
  get list(): ProposalItem[] {
    return this.proposalList;
  }

  // 共通処理からご提案一覧を保持する
  setList(payload: ProposalItem[]) {
    this.proposalList = payload;
  }

  // ご提案の選択状態からスタート可否判定用の状態を更新する
  checkDisableStart(arrData: ProposalItem[], isUnSelect?: boolean) {
    let checked: boolean = false;
    if (isUnSelect) {
      checked = true;
    } else if (arrData) {
      checked = arrData.some((data: ProposalItem) => data.isCheck === 1);
    }
    this.setNowSelected(checked);
  }

  // テンプレート表示用のご提案選択肢リストを生成する
  getTargetList() {
    return this.list.map((data: ProposalItem) => {
      const key = data.proposalId || data.num;
      return {
        "mode": 1,
        "btnDel": false,
        "btnSel": data.isCheck === 1,
        "btnFre": !(data.isCheck === 1),
        "btnUse": false,
        "key": key,
        "dataSet": key,
        "isDisabled": false,
        "icon": "",
        "label": data.proposalNm,
        "labelEntends1": 0,
        "labelEntends2": 0,
      };
    });
  }

  // スタート時に選択中のご提案を保存データへ反映する
  setStartInspectDetail(inspectionDetail: InspectDetail) {
    inspectionDetail.proposal = this.list
      .filter((data: ProposalItem) => data.isCheck === 1)
      .map((data: ProposalItem) => {
        return {
          num: data.num,
          proposalId: data.proposalId,
          proposalNm: data.proposalNm
        };
      });
  }

  // 取得済みの検査構成からご提案の初期選択情報を反映する
  applyInitialInspectionDetail(data: any, inspectionDetail?: InspectDetail) {
    if (inspectionDetail) {
      inspectionDetail.proposal = data.proposal || [];
    }
    return { data, inspectionDetail };
  }

  // ご提案の選択クリックを処理する
  select(key: number | string) {
    const proposalList = this.list.map((data: ProposalItem) => {
      const dataKey = data.proposalId || data.num;
      if (dataKey == key) {
        const isChecked = data.isCheck === 1;
        data.isCheck = isChecked ? 0 : 1;
        if (!isChecked) {
          this.deSelProposal = false;
        }
      }
      return data;
    });
    this.setList(proposalList);
    this.checkDisableStart(proposalList, this.deSelProposal);
  }

  // ご提案で「選択無し」を表示できるか返す
  canDeSelect() {
    return true;
  }

  // ご提案が「選択無し」状態か返す
  isDeSelected() {
    return this.deSelProposal;
  }

  // ご提案の「選択無し」状態を切り替える
  deSelect() {
    const proposalList = this.list;
    if (!this.deSelProposal) {
      proposalList.map(data => (data.isCheck = 0));
    }
    this.deSelProposal = !this.deSelProposal;
    this.setList([...proposalList]);
    this.checkDisableStart(proposalList, this.deSelProposal);
    return this.deSelProposal;
  }

  // 共通呼び出し用の「選択無し」クリック処理
  clickDeSelect() {
    return this.deSelect();
  }

  // Storeに既存リストがある場合に選択状態を再評価する
  applyExistingList() {
    const proposalList = this.list;
    this.checkDisableStart(proposalList, this.deSelProposal);
    return proposalList;
  }

  // API取得結果からご提案一覧の初期選択状態を作成する
  setInitialList(res: CouponData, selectedProposal: ProposalItem[] | undefined, initialDeSelected?: boolean) {
    const responseItems = res && res.proposal && res.proposal.items ? res.proposal.items : [];
    const proposalList = responseItems.map((data: ProposalItem) => {
      const selected = selectedProposal
        ? selectedProposal.some((proposal: ProposalItem) => data.proposalId == proposal.proposalId)
        : false;
      data.isCheck = selected || data.isCheck === 1 ? 1 : 0;
      return data;
    });
    this.deSelProposal = initialDeSelected === true
      && !proposalList.some((data: ProposalItem) => data.isCheck === 1);
    this.setList(proposalList);
    this.checkDisableStart(proposalList, this.deSelProposal);
    return proposalList;
  }

  // ご提案一覧を既存保持データまたはAPIから取得する
  getDataList(
    loadInitialList: () => Promise<CouponData>,
    selectedProposal: ProposalItem[] | undefined,
    initialDeSelected?: boolean
  ) {
    if (this.list.length > 0) {
      this.applyExistingList();
      return {
        hasExistingList: true,
        promise: null
      };
    }
    return {
      hasExistingList: false,
      promise: loadInitialList().then((res: CouponData) => {
        return this.setInitialList(res, selectedProposal, initialDeSelected);
      })
    };
  }
}
